import _extends from 'babel-runtime/helpers/extends';

import 'echarts/lib/chart/line';

export default {
  props: {
    pointData: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    computedOptions: function computedOptions() {
      var baseConfig = {
        tooltip: {
          // 提示器
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          // 直角坐标系
          top: '6%',
          left: '6%',
          right: '6%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: _extends({
          // 横坐标
          type: 'category',
          boundaryGap: false,
          data: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '']
        }, this.pointData.option.xAxis),
        yAxis: {
          // 纵坐标
          type: 'value'
        },
        series: [
        // 折线
        _extends({
          data: [820, 932, 901, 934, 1290, 1330, 1320],
          type: 'line',
          symbol: 'none',
          areaStyle: {
            // 折现区域内样式
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#E57253' // 0% 处的颜色
              }, {
                offset: 1,
                color: '#fff' // 100% 处的颜色
              }],
              globalCoord: false // 缺省为 false，若为true，则四个位置为绝对像素的值
            }
          },
          itemStyle: {
            color: '#E57253' // 改变折线颜色
          }
        }, this.pointData.option.series[0])]
      };
      return baseConfig;
    }
  }
};